import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TCreateConversionFinalDraftsAPIParams, TCreateConversionFinalDraftsParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateGoldConversionFinalDrafts(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldCreateGoldConversionFinalDraftsAttempt', handleCreateGoldConversionFinalDrafts, api);
}

function* handleCreateGoldConversionFinalDrafts(api: GoldGateway, action: PayloadAction<TCreateConversionFinalDraftsParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        customerId,
        branchId,
        originProductId,
        targetProductId,
        quantity,
        serialNoIds,
        salesPersonnelName,
        referralName,
        metalType,
    } = action.payload;

    const response = yield* call([api, api.createGoldConversionFinalDrafts], {
        authToken,
        id,
        customerId,
        branchId,
        originProductId,
        targetProductId,
        quantity,
        serialNoIds,
        salesPersonnelName,
        referralName,
        metalType,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldCreateConversionFinalDraftsFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldCreateConversionFinalDraftsSuccess(action.payload));
        yield put(combinedActions.goldSetIsFormFilled(true));
    }
}
